export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_NOTIFICATIONLOADER = "SET_NOTIFICATIONLOADER";
export const SET_CLOSENOTIFICATIONLOADER = "SET_CLOSENOTIFICATIONLOADER";
export const SET_CHAT_NOTIFICATION = "SET_CHAT_NOTIFICATION";
export const RESET_CHAT_NOTIFICATION = "RESET_CHAT_NOTIFICATION";
